import React,{Component} from 'react';
import Button from '@mui/material/Button';
import ReactDOM from 'react-dom';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import CloudUpload from '@mui/icons-material/CloudUpload';

class FileUpload extends Component
{
    state=
    {
        uploading:false,
        file:"",
        fileName:""
    };
    componentWillMount()
    {
        if(this.props.value)
            this.setState(this.props.value);
    }
    componentWillReceiveProps(newProps)
    {
        if(newProps.value)
            this.setState({fileName: newProps.value});
    }
    openFileDialog =()=> {
        var fileInputDom = ReactDOM.findDOMNode(this.refs.fileUpload)
        fileInputDom.click()
      }
      handleFile=(event)=>
      {
        if(event.target.files&&event.target.files.length)
        {
            this.setState({fileName:event.target.files[0].name});
            const formData= new FormData();
            formData.append(this.props.name, event.target.files[0], event.target.files[0].name);
            
            if (this.props.needProccess) {
                let imageFileName = "file" + "_" + Date.now() + "_" + event.target.files[0].name.replace(new RegExp("[^a-zA-Z0-9\\.]", 'g'), '_');
                this.setState({ file: event.target.files[0], fileName: imageFileName, uploading: false });
                return this.props.getFile(event.target.files[0], imageFileName)
            }

            if (this.props.onUpload) {
                this.setState({uploading: true })
                this.props.onUpload(formData).then(uploadedFile => {
                    if(!this.props.handled) {
                        this.setState({file:uploadedFile,uploading:false});
                    } else {
                        this.setState({file:null,uploading:false});
                    }
                    this.props.onChange({file:uploadedFile,file_name:this.state.fileName});
                }).catch(error=> {
                    this.setState({ file: "", fileName: "", uploading: false });
                    this.props.onError();
                });
            } else {
                this.props.onChange({ file: event.target.files[0], file_name: event.target.files[0].name , uploading: false });
            }
        }
      }
      handleDelete=()=>
      {
          if(!this.props.disabled)
          {
            this.setState({file:"",fileName:""});
            this.props.onChange(null);
          }
          
      }
    render()
    {
        return (
            <div>
                {this.state.uploading&&<LinearProgress color={this.props.color} />}
                {this.state.file&&<Chip clickable={!this.props.disabled} className="overflowchip" onClick={()=>{
                    if(!this.props.disabled&&this.props.onClick)
                        this.props.onClick();
                }}
        label={this.state.fileName}
        onDelete={this.handleDelete}
        variant="outlined"
      />}
              {!this.state.uploading&&!this.state.file&&<div><Button className="upload-button"
                variant={this.props.variant}
                color={this.props.color}
                onClick={this.openFileDialog}>
                <CloudUpload className="margin-rigth10" />
                {this.props.label}</Button>
              <input
                type='file'
                multiple={this.props.multi}
                ref='fileUpload'
                style={{ display: 'none' }}
                accept={this.props.accept}
                onChange={this.handleFile} />
            </div>}
            </div>
          );
    }
    
}

export default FileUpload;